module.exports = {
      id: "shortform-usage",
      viewBox: "0 0 13.07 13.758",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#shortform",
      toString: function () {
        return this.url;
      }
    }